
import { useSearchParams } from "react-router";
import { Breadcrumb } from "@/components/Breadcrumb";
import "./GestionFases.css";
import { TablaFases } from "./TablaFases";
import { usePuestosConCarga, type Puesto } from "@/hooks/Api/Puestos";
import { Loading } from "@/components/Loading/Loading";

export function GestionFasesPage() {
	const [search] = useSearchParams();

	const puesto = search.get("idPuesto") ?? "";

	return (
		<div id="content" className="content" >
			<title>Piher | Gestión de Fases </title>

			{puesto == "" && (
				<ContenedorPuestos />
			)}
			{puesto != "" && (
				<TablaFases idPuesto={puesto} />
			)}
		</div>
	);
}


function ContenedorPuestos() {
	const { data, isLoading, error } = usePuestosConCarga();

	if (error) {
		return <div>Error al cargar los puestos</div>;
	}
	return (
		<>
			<Breadcrumb
				sectionTitle="Gestión de Puestos"
				links={[
					{ label: "Gestión de Puestos", active: true }
				]}
			/>
			<div id="contenedorBotones">
				{isLoading ? <Loading /> : data?.map(puesto => (
					<BotonPuesto key={puesto.idPuesto} puesto={puesto} />
				))}
			</div>
		</>
	);

}
function BotonPuesto(props: { readonly puesto: Puesto; }) {
	const [_, setSearch] = useSearchParams();
	const onClick = () => { setSearch({ idPuesto: props.puesto.idPuesto }); };

	return (
		<button className="botonPuesto" onClick={onClick} type="button">
			<h3 className="idPuesto">{props.puesto.idPuesto}</h3>
			<h4 className="nombrePuesto">{props.puesto.descripcion.replace(props.puesto.idPuesto, "")}</h4>
			<div style={{ flex: 1 }} />
			<div className="indicadorHoras">
				Carga de trabajo: <b>{props.puesto.cantidadHoras}h</b>
			</div>
		</button>
	);
}





export interface RespuestaFases {
	status: "success";
	fases: Fase[];
}
export interface RespuestaOrden {
	status: "success";
	orden: Array<{ idOF: number; faseOF: number; idPuesto: string; orden: number; }>;
}
export interface Fase {
	idOF: number;
	idPuesto: string;
	idRuta: string;

	idFase: number;
	descripcionFase: string;

	idArticulo: string;
	descripcionArticulo: string;

	cantAcabada: number | null;
	cantLanzada: number | null;
	cantRechazada: number | null;
	cantidadOF: number | null;

	timestampIni: number | null;
	timestampFin: number | null;
}

export interface ArticuloStock {
	idArticulo: string;
	max: number | null;
	min: number | null;
	pendienteEntrada: number | null;
	pendienteSalida: number | null;
	stock: number | null;
	entrarRecomendado: number;
};

export interface ResPrintOF {
	status: string;
	message: string;
	printPDF: string;
}

export interface ResOrderPuesto {
	status: string;
	message: string;
	ordenPDF: string;
}

export interface PrintData {
	count: number;
	last: number;
};
